/** Warm the lazy whiteboard editor chunk (tldraw + sync) before navigation. */
export function preloadWhiteboardEditor() {
    return import('./WhiteboardEditorWorkspace');
}
